import TeamMemberInvite from '../legacy/pages/TeamMemberInvite';
import Baa from '../legacy/pages/Baa';
import TOS from '../legacy/pages/TOS';

export const ROOT_PATH = {
  TEAM_MEMBER_INVITE: '/invite',
  BAA: '/baa',
  TOS: '/tos-eea',
};

const routes = [
  /* external route */
  {
    exact: true,
    path: '/pp-en',
    component: () => {
      window.location = 'http://www.alivecor.com/privacy/en';
      return null;
    },
  },
  {
    exact: true,
    path: `${ROOT_PATH.TEAM_MEMBER_INVITE}/:inviteCode`,
    component: TeamMemberInvite,
  },
  {
    exact: true,
    path: ROOT_PATH.BAA,
    component: Baa,
  },
  {
    exact: true,
    path: ROOT_PATH.TOS,
    component: TOS,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/publicRoutes.jsx